<template>
    <el-container class="strategy-list" v-wechat-title="$route.meta.title">
        <el-main>
            <div class="strategy-list-content">
                <div class="strategy-title column-header">
                    <span>策略列表</span>
                    <el-button class="btn__style" @click="strategyConfig('add', -1)" v-if="isSuper == 1"><i class="el-icon-plus"></i>添加策略</el-button>
                </div>
                <div class="strategy-info">
                    <div class="strategy-header">
                        <!-- <el-button @click="strategyConfig('add', -1)" v-if="isSuper == 1"><i class="el-icon-plus"></i>添加策略</el-button> -->
                        <el-dialog :visible.sync="dialogVisible">
                            <div class="dialog-title">
                                <h3 v-if="operation == 'add'">添加策略</h3>
                                <h3 v-else-if="operation == 'config'">配置策略</h3>
                            </div>
                            <el-divider></el-divider>
                            <form action="" method="post" class="form-horizontal" id="upload">
                                <div class="form-group main-file clearfloat">
                                    <div>
                                        <label for="">选取主文件：</label>
                                    </div>
                                    <div>
                                        <input type="text" class="form-control" v-model="mainFileName">
                                        <span @click="showFiles"><i class="fa fa-folder-open" aria-hidden="true"></i>浏览文件</span>
                                        <input type="file" class="form-control" name="mainFile" id="mainFile" @change="fileChange($event)" style="display: none">
                                    </div>
                                </div>
                                <div class="form-group other-file">
                                    <div class="other-file-title">
                                        <label for="">其他的文件：</label>
                                        <span @click="showrelyFiles"><i class="fa fa-folder-open" aria-hidden="true"></i>添加文件</span>
                                    </div>
                                    <div class="file-list" v-show="fileVisible">
                                        <ul>
                                            <li v-for="(fileName, index) in relyFileList" :key="index">{{fileName}} <i class="fa fa-times-circle" @click="deleteFile(index)" aria-hidden="true"></i></li>
                                        </ul>
                                    </div>
                                    <input type="file" class="form-control" name="moreFile" multiple="multiple" id="moreFile" @change="moreFileChange($event)" style="display: none">
                                </div>
                            </form>
                            
                            <el-divider></el-divider>
                            <div class="dialog-param">
                                <div class="dialog-item clearfloat">
                                    <label>策略 ID：</label>
                                    <input type="text" placeholder="填写策略ID" v-model="strategySoleId">
                                </div>
                                <div class="dialog-item clearfloat">
                                    <label>策略名称：</label>
                                    <input type="text" placeholder="填写策略名称" v-model="strategyName">
                                </div>
                                <!-- <div class="dialog-item clearfloat">
                                    <label>初始资金：</label>
                                    <input type="text" placeholder="填写初始资金" v-model="initialMoney">
                                </div> -->
                            </div>
                            <el-divider v-if="pyparamVisible" content-position="left"><h4>参数显示：</h4></el-divider>
                            <div class="dialog-add-param">
                                <div v-if="pyparamVisible">
                                    <div v-for="(pyText, pyIndex) in pyParamData" :key="pyIndex" class="dialog-item clearfloat">
                                        <label>{{pyIndex}}：</label>
                                        <input type="text" placeholder="填写初始资金" v-model="pyParamData[pyIndex]">
                                    </div>
                                </div>
                                <p v-else>{{pyError}}</p>
                            </div>
                            <el-divider></el-divider>
                            <div class="dialog-btn">
                                <el-button @click="submitStrategy">提交</el-button>
                            </div>
                        </el-dialog>
                    </div>
                    <table class="table">
                        <thead>
                            <tr>
                                <!-- <th><el-checkbox></el-checkbox></th> -->
                                <th>策略ID</th>
                                <th>名称</th>
                                <th>更新时间</th>
                                <th>操作</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(strategy, index) in strategyList" :key="index">
                                <!-- <td><el-checkbox></el-checkbox></td> -->
                                <td>{{strategy.strategy_sole_id}}</td>
                                <td><i class="el-icon-document"></i>
                                     <el-popover custom-class="stategy-popover" placement="right" width="400" trigger="manual" v-model="popVisible[strategy.id]">
                                        <div class="pop-content">
                                            <div class="pop-title">
                                                <h3>策略配置</h3>
                                            </div>
                                            <el-divider></el-divider>
                                            <div class="pop-content">
                                                <el-form :label-position="labelPosition" label-width="120px">
                                                    <el-form-item label="策略ID" style="margin-bottom: 0;padding:0 20px;">
                                                        <input type="text" v-model="stategyDefaultParam.strategyId" style="font-size: 12px; width: 100%; outline-color: #969696;">
                                                    </el-form-item>
                                                    <el-form-item label="策略名称" style="margin-bottom: 0;padding:0 20px;">
                                                        <input type="text" v-model="stategyDefaultParam.strategyName" style="font-size: 12px; width: 100%; outline-color: #969696;">
                                                    </el-form-item>
                                                    <el-form-item v-for="(item, index2) in defaultParams" :key="index2" :label="showName(item, index2)" style="margin-bottom: 0;padding:0 20px;">
                                                        <el-switch v-if="index2 == 'is_borrow'" v-model="defaultParams[index2]"></el-switch>
                                                        <input v-else type="text" v-model="defaultParams[index2]" style="font-size: 12px; width: 100%; outline-color: #969696;"><i v-if="isSuper == 1" @click="deleteStrategyParam(item, index2)" class="fa fa-times-circle" aria-hidden="true"></i>
                                                    </el-form-item>
                                                    <el-divider v-if="isSuper == 1"><strong>添加参数</strong></el-divider>
                                                    <div v-if="isSuper == 1" style="margin-bottom: 0;padding:0 20px;">
                                                        <FillParam @addParam="addNewParamToParam"></FillParam>
                                                    </div>
                                                </el-form>
                                            </div>
                                            <!-- <el-divider></el-divider> -->
                                            <div class="pop-footer" style="text-align: right">
                                                <el-button class="pop-btn" @click="cancelEvent(strategy.id)">关闭</el-button>
                                                <el-button v-if="isSuper == 1" class="pop-btn" @click="saveStrategyParam(strategy.id)">保存</el-button>
                                            </div>
                                        </div>
                                        <el-button slot="reference" style="color: #db5634" @click="showStrategyParam(strategy.id, index)"> {{strategy.name}}</el-button>
                                    </el-popover>
                                </td>
                                <td>{{strategy.updatetime}}</td>
                                <td>
                                    <el-dropdown trigger="click" v-if="isSuper == 1">
                                        <el-button>
                                            操作<i class="el-icon-arrow-down el-icon--right"></i>
                                        </el-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item @click.native="deleteStrategy(strategy.id)">删除</el-dropdown-item>
                                            <el-dropdown-item @click.native="strategyConfig('config', strategy)">配置</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                    <span v-else>没有权限</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </el-main>
    </el-container>
</template>

<script>
/* eslint-disable */
import Header from '@/components/header/Header.vue'
import Footer from '@/components/Footer/New-footer.vue'
import FillParam from '@/views/strategy/Fill-param.vue'
import { get, post, del, put } from '@/api/index'
import { mapState, mapActions } from 'vuex';

export default {
    components: {
        Header,
        Footer,
        FillParam,
    },
    data() {
        return {
            dialogVisible: false,
            mainFile: '',
            moreFile: '',
            paramNum: 0,
            strategySoleId: '',
            strategyName: '',
            initialMoney: '',
            formData: new FormData(),
            mainFileName: '',
            mainFiles: {},
            relyFileList: [],
            relyFileInfoList: [],
            fileVisible: false,
            relyFileObj: {},
            isSuper: sessionStorage.getItem('isSuper'),
            labelPosition: 'right',
            stategyDefaultParam: {'strategyId': '', 'strategyName': '', 'initialMoney': ''},
            pyparamVisible: false ,
            pyParamData: {},
            pyError: '',
            strategyConfigParam: {},
            defaultParams: {},
            operation: 'add',
            popVisible: {},
        }
    },
    mounted() {
        this.isSuper = this.$cookies.get('isSuper');
        this.getStrategyList().then(data => {
            data.map((value, key) => {
                this.$set(this.popVisible, value.id, false);
            })
        })
        this.getBourseList();
    },
    computed: {
        ...mapState([
            'token',
            'strategyList',
            'addTask',
            'currencyList',
            'addTask',
            'strategyParam',
        ])
    },
    methods: {
        ...mapActions([
            'getStrategyList',
            'getBourseList',
            'getStrategyParam',
            'getStrategyParam2'
        ]),

        // 文件浏览
        showFiles() {
            $('input[id=mainFile]').click();
        },

        // 多文件浏览
        showrelyFiles() {
            $('input[id=moreFile]').click();
        },

        // 删除文件
        deleteFile(index) {
            this.relyFileList.splice(index, 1);
            if (this.relyFileList.length == 0) {
                this.fileVisible = false;
            }
        },

        // 提交策略
        submitStrategy(){
            this.formData = new FormData();
            this.formData.append('defaultParams', JSON.stringify(this.pyParamData));
            this.formData.append('strategySoleId', this.strategySoleId);
            this.formData.append('strategyName', this.strategyName);
            this.formData.append('initialMoney', this.initialMoney);
            this.formData.append('token', this.token);
            // 将多文件 放入一个对象中
            var relyOnFiles = {};
            this.relyFileInfoList.map((value, index) => {
                this.formData.append('relyOnFiles', value);
            })

            this.formData.append('file', this.mainFiles);
            var url = this.$baseUrl + '/save_strategy_files';
            if (this.pyError !== 'null') {
                this.$notify.error({
                    message: this.pyError,
                    title: '提示',
                    offset: 100
                })
                return;
            }

            post(url, this.formData).then(resp => {
                if (resp.code == 200) {
                    this.$notify.info({
                        message: '提交成功!',
                        title: '提示',
                        offset: 100
                    })
                    this.dialogVisible = false;
                    this.pyError = '';
                    this.getStrategyList().then(data => {
                        data.map((value, key) => {
                            this.$set(this.popVisible, value.id, false);
                        })
                    })
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        },

        // 主文件的上传事件
        fileChange(e) {
            var fileData = e.srcElement.files;

            this.mainFileName = fileData[0].name;
            this.mainFiles = fileData[0];
            // 读取上传 pyd 文件的参数
            var reader = new FileReader();
            reader.readAsText(fileData[0]);
            this.getTextInfo(reader).then(data => {
                // 可以解析 py文件
                this.pyParamData = data;
                this.pyparamVisible = true;
                this.pyError = 'null';
            }).catch(error => {
                // 无法解析 py 文件
                this.pyparamVisible = false;
                this.pyError = error;
                this.$notify.error({
                    message: error,
                    title: '提示',
                    offset: 100
                })
            })
            $('#mainFile').val('');
        },

        // 封装的 文件读取函数
        getTextInfo(reader) {
            return new Promise((resolve, reject) => {
                reader.onload = function () {
                    if (this.result[0] == '#') {
                        var py_data = this.result.split('/')[1];
                        resolve(JSON.parse(py_data))
                    } else {
                        reject('无法解析该文本!');
                    }
                }
            })
        },

        // 多文件的上传
        moreFileChange(e) {
            var moreFiles = document.getElementById('moreFile').files;
            for (var i in moreFiles) {
                if (typeof moreFiles[i] == 'object') {
                    this.relyFileList.push(moreFiles[i].name);
                    this.relyFileInfoList.push(moreFiles[i]);
                }
            }
            $(e.srcElement).val('');
            this.fileVisible = true;
        },

        // 策略删除
        deleteStrategy(strategyId) {
            this.$confirm('是否删除此策略?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 点击确定后的操作
                var url = this.$baseUrl + '/strategy/delete';
                var param = {
                    'token': this.token,
                    'strategyId': strategyId
                };
                del(url, param).then(resp => {
                    if (resp.code == 200) {
                        this.$notify.info({
                            message: '删除成功!',
                            title: '提示',
                            offset: 100
                        })
                        this.getStrategyList().then(data => {
                            data.map((value, key) => {
                                this.$set(this.popVisible, value.id, false);
                            })
                        })
                    } else {
                        this.$notify.error({
                            message: resp.info,
                            title: '提示',
                            offset: 100
                        })
                    }
                })
            }).catch(() => {
                // 点击取消后的操作
            })

        },

        // 展示策略参数
        showStrategyParam(strategyId, index) {
            for (var i in this.popVisible) {
                if (i !== String(strategyId)) {
                    // 将其它策略 设为false
                    this.popVisible[i] = false;
                }
            }
            this.popVisible[strategyId] = !this.popVisible[strategyId];
            // 获取 策略参数api
            this.addTask.strategySelect = strategyId;
            // 获取策略参数
            this.getStrategyParam2().then(data => {
                if (JSON.stringify(this.defaultParams !== '{}')) {
                    // 如果 this.defaultParams 里有值则 初始化
                    this.defaultParams = {};
                }
                for (var i in data) {
                    this.$set(this.defaultParams, i , data[i]);
                }
                var strategyData = this.strategyList[index];
                this.stategyDefaultParam.strategyId = strategyData.id;
                this.stategyDefaultParam.strategyName = strategyData.name;
                this.stategyDefaultParam.initialMoney = strategyData.initial_money;
            })
        },

        // 展示字段名字
        showName(item, name) {
            if (name == 'currency_type') return '币种';
            else if (name == 'a_bourse' || name == 'b_bourse') return '交易所名称';
            else if (name == 'a_transaction_type' || name == 'b_transaction_type') return '交易类型';
            else if (name == 'fund_occupy') return '资金可占用比';
            else if (name == 'virtual_initial_capital') return '任务虚拟初始资金';
            else if (name == 'is_borrow') return '是否允许可借贷';
            return name;
        },

        // 保存参数修改
        saveStrategyParam(strategyId) {
            var url = this.$baseUrl + '/strategy/update?token='+this.token+'&strategyId='+this.stategyDefaultParam.strategyId+'&strategyName='+this.stategyDefaultParam.strategyName+
                        '&initialMoney='+this.stategyDefaultParam.initialMoney+'&defaultParams='+JSON.stringify(this.defaultParams);
            put(url).then(resp => {
                if (resp.code == 200) {
                    this.$notify.info({
                        message: '保存成功',
                        title: '提示',
                        offset: 100
                    })
                    // 关闭弹窗
                    this.popVisible[strategyId] = false;
                    // 列表刷新
                    this.getStrategyList();
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100
                    })
                }
            }).catch(error => {
                console.log(error);
            })
        },

        // 删除策略配置参数
        deleteStrategyParam(item, index) {
            this.$delete(this.defaultParams, index, item);
        },

        // 向参数里添加新参数
        addNewParamToParam(value, key) {
            if (value !== '' || key !== '') {
                this.$set(this.defaultParams, key, value);
            }
        },

        // 策略配置 修改
        strategyConfig(operation, data) {
            this.operation = operation;
            // 清空回显
            this.relyFileList = [];
            this.mainFileName = '';
            this.pyparamVisible = false;
            if (data !== -1) {
                // 如果data 不为-1，此时为回显数据
                this.strategySoleId = data.strategy_sole_id;
                this.strategyName = data.name;
                this.initialMoney = data.initial_money;
            } else {
                // 此时 为添加策略，值设置为空
                this.strategySoleId = '';
                this.strategyName = '';
                this.initialMoney = '';
            }
            this.dialogVisible = true;
        },

        // 关闭 popover 窗口
        cancelEvent(strategyId) {
            this.popVisible[strategyId] = false;
        }
    }
}
</script>

<style lang="scss">
    .pop-btn{
        padding: 5px 10px;
        background-color: #524e4e;
        border-color: #524e4e;
        color: #969696;
    }
    .el-popover{
        &.stategy-popover {
            width: 50%;
        }
        .popper__arrow{
            background-color: #262829;
        }
        .pop-content{
            .pop-title{
                h3{
                    text-align: center;
                }
            }
            form{
                input{
                    outline: 0;
                    padding: 5px;
                    border: 1px solid #1e1e1e;
                    border-radius: 3px;
                    color: #969696;
                    line-height: 20px;
                    width: 90% !important;
                    background-color: #1e1e1e;
                }
                i:hover{
                    cursor: pointer;
                }
                .el-form-item__content{
                    margin-left: 0;
                }
                .el-divider{
                    margin-bottom: 20px;
                    margin-top: 20px;
                    .el-divider__text{
                        background-color: #262829;
                        color: #929292;
                    }
                    .el-button{
                        padding: 5px 10px;
                        background-color: #524e4e;
                        border-color: #524e4e;
                        color: #969696;
                    }
                }
            }
        }
    }
    .strategy-list{
        .el-main{
            // padding: 15px 0;
            background-color: #252425;
            height: 650px;
        }
        
        .strategy-list-content{
            width: 100%;
            // margin: 10px auto;
            background-color: #2a2d2e;
            .strategy-title{
                // padding: 10px;
                background-color: #1e1e1e;
                display: flex;
                justify-content: space-between;
                h3{
                    text-align: left;
                    color: #A7A7A7;
                }
            }
            .strategy-info{
                .strategy-header{
                    text-align: left;
                    .el-dialog{
                        .main-file{
                            margin: 10px;
                            span{
                                border: 0px solid #969696;
                                border-left: 0;
                                padding: 5px;
                                background-color: #969696;
                            }
                            span:hover{
                                cursor: pointer;
                            }
                            input{
                                padding: 5px;
                                color: #3e4040;
                            }
                            div{
                                float: left;
                            }
                        }
                        .other-file{
                            margin: 10px;
                            span{
                                padding: 5px;
                                background-color: #969696;
                                border-radius: 3px;
                            }
                            span:hover{
                                cursor: pointer;
                            }
                            .file-list{
                                width: 70%;
                                padding: 5px;
                                margin-top: 10px;
                                ul{
                                    li{
                                        padding: 3px;
                                        i:hover{
                                            cursor: pointer;
                                        }
                                    }
                                    li:hover{
                                        background-color: #969696;
                                    }
                                }
                            }
                        }
                        .dialog-title{
                            color: #787979;
                            h3{
                                text-align: center;
                                padding: 10px 5px 0px 5px;
                                font-size: 20px;
                            }
                        }
                        .el-dialog__body{
                            .el-divider{
                                margin: 10px 0;
                            }
                        }
                        .dialog-param{
                            padding: 5px;
                            .dialog-item{
                                margin-bottom: 10px;
                                .el-select{
                                    margin-right: 10px;
                                }
                                label{
                                    min-width: 80px;
                                    padding: 5px;
                                    display: inline-block;
                                }
                                input{
                                    padding: 5px;
                                    // border-radius: 3px;
                                    margin-right: 10px;
                                    width: 50%;
                                    font-size: 13px;
                                }
                            }
                        }
                        .dialog-add-param{
                            padding: 5px;
                            .dialog-fill-param{
                                p{
                                    margin: 10px 0;
                                }
                            }
                            .dialog-item{
                                color: #606266;
                                margin-bottom: 10px;
                                label{
                                    display: inline-block;
                                    min-width: 80px;
                                    color: #606266;
                                    padding: 5px 5px 5px 0;
                                }
                                input{
                                    padding: 5px;
                                    color: #606266;
                                    font-size: 13px;
                                    width: 50%;
                                }
                            }
                        }
                        .dialog-btn{
                            text-align: right;
                            padding: 10px;
                            .el-button{
                                padding: 10px 15px;
                            }
                        }
                    }
                    .el-button{
                        padding: 10px;
                        background-color: #333333;
                        border-color: #333333;
                        color: #929292;
                    }
                    .el-button:hover{
                        background-color: #524e4e;
                    }
                }
                .show-more{
                    margin-top: 10px;
                    color: #787979;
                    text-align: right;
                    span{
                        padding: 7px 10px;
                        background-color: #524e4e;
                        border-radius: 3px;
                        color: #fff;
                        font-size: 14px;
                    }
                    span:hover{
                        cursor: pointer;
                    }
                }
                .table{
                    width: 100%;
                    color: #787979;
                    text-align: center;
                    border-radius: 5px;
                    margin-top: 10px;
                    padding: 10px;
                    border-collapse: collapse;
                    thead{
                        background-color: #1e1e1e;
                        th{
                            padding: 10px 5px;
                            border-color: #1e1e1e;
                        }
                    }
                    tbody{
                        padding: 5px;
                        tr{
                            td{
                                padding: 15px 5px;
                                border-bottom: 1px solid #3e4040;
                                color: #787979;
                                .el-dropdown{
                                    color: #969696;
                                    .el-button{
                                        padding: 8px 10px;
                                        background-color: #333333;
                                        border-color: #333333;
                                        color: #969696;
                                    }
                                }
                                span{
                                    .el-button{
                                        background-color: #2b2b2b;
                                        border-color: #2b2b2b;
                                        color: #969696;
                                        padding: 0;
                                        font-size: 13px;
                                    }
                                }
                                input{
                                    padding: 5px;
                                    outline: 0;
                                    border: 1px solid #969696;
                                }
                            }
                        }
                        tr:hover{
                            background-color: #1e1e1e;
                            border-color: #1e1e1e;
                            td{
                                color: #fff;
                            }
                        }
                    }
                }

                .el-table{
                    border-radius: 5px;
                    .el-table__header-wrapper{
                        table{
                            thead{
                                tr{
                                    background-color: #1e1e1e;
                                    th{
                                        background-color: #000;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    @media screen and (min-width: 1100px) {
        .strategy-list{
            .el-main{
                margin: 0;
            }
        }
        .el-popover{
            width: 600px;
        }
    }

    @media screen and (max-width: 680px) {
        .strategy-list{
            .el-main{
                padding: 10px 5px;
                margin: 0;
                .el-dialog{
                    width: 350px;
                }
            }
        }
        .el-popover{
            width: 300px !important;
            .pop-content{
                .el-form{
                    .el-form-item{
                        padding: 0 !important;
                        label{
                            font-size: 12px;
                            width: 90px !important;
                        }
                        .el-form-item__content{
                            margin-left: 90px !important;
                            input{
                                width: 80% !important;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
